export default __webpack_public_path__ + "5013690cfb82cef145ad8d6f66c819b9.svg";